import $axios from '~/plugins/axios';

import { Api, GetPromoCategoryParams, PaginatorResult, PromoCategory } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'promoCategoriesPage',
			pageSizeQueryKey: 'promoCategoriesPerPage',
			itemCountGetter: 'promoCategories/list/totalCount',
		}),
	})
	.withState({
		storedPromoCategories: {} as Dict<PromoCategory>,
		promoCategories: [] as PromoCategory[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byUuid: state => (promoUuid: string) => (
			state.storedPromoCategories[promoUuid] ?? null
		),
		page: state => state.promoCategories,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_PROMO_CATEGORIES (state, categories: PromoCategory[]) {
			state.storedPromoCategories = {
				...state.storedPromoCategories,
				...createDict(categories, (category) => category.uuid),
			};
		},
		SET_PROMO_CATEGORIES (state, promoUuids: string[]) {
			state.promoCategories = promoUuids.map(uuid => state.storedPromoCategories[uuid]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetPromoCategoryParams = {}) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/promo-category', { params });
			commit('SET_LOADING', false);

			const categories = data.payload;
			const categoryUuids = categories.map(promo => promo.uuid);

			commit('SET_STORED_PROMO_CATEGORIES', categories);
			commit('SET_PROMO_CATEGORIES', categoryUuids);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
